import { IOnboardingData } from '@utils';

export const OnboardingData: IOnboardingData[] = [
  {
    url: 'yandex',
    name: 'Яндекс',
    images: ['/onboarding/yandex.png'],
  },
  {
    url: 'outlook',
    name: 'Outlook',
    images: ['/onboarding/outlook.png'],
  },
  {
    url: 'google',
    name: 'Google',
    images: ['/onboarding/google.png'],
  },
  {
    url: 'mail',
    name: 'Mail.ru',
    images: [
      '/onboarding/mail0.png',
      '/onboarding/mail1.png',
      '/onboarding/mail2.png',
      '/onboarding/mail3.png',
    ],
  },
  {
    url: 'thunderbird',
    name: 'Thunderbird',
    images: [
      '/onboarding/thunderbird0.png',
      '/onboarding/thunderbird1.png',
      '/onboarding/thunderbird2.png',
      '/onboarding/thunderbird3.png',
      '/onboarding/thunderbird4.png',
      '/onboarding/thunderbird5.png',
    ],
  },
];
